var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "overview-section"
  }, [_c('b-container', {
    attrs: {
      "fluid": "xl"
    }
  }, [_c('h3', {
    staticClass: "title mb-4"
  }, [_vm._v("Overview")]), _c('b-row', {
    staticClass: "justify-content-md-center"
  }, _vm._l(_vm.stats, function (item, index) {
    return _c('b-col', {
      key: index,
      staticClass: "mb-4",
      attrs: {
        "cols": "12",
        "md": "6",
        "xl": "4"
      }
    }, [_c('b-card', {
      staticClass: "flex-column flex-column-reverse flex-md-row align-top",
      attrs: {
        "no-body": ""
      }
    }, [_c('div', {
      staticClass: "d-flex flex-column justify-content-center justify-content-sm-start text-center text-md-left flex-grow-1"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(item.label))]), _c('h3', {
      staticClass: "card-heading"
    }, [_c('span', [_vm._v(_vm._s(item.value))]), item.unit ? _c('span', {
      staticClass: "text-secondary"
    }, [_vm._v(_vm._s(item.unit))]) : _vm._e()]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(item.subtext))])]), _c('div', {
      staticClass: "icon-circle flex-shrink-0 mx-auto ml-sm-auto"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": item.label
      }
    })])])], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }